__turbopack_context__.v({
  "carouselShell": "CustomerSaysSection-module-scss-module__4pvHGa__carouselShell",
  "carouselWrapper": "CustomerSaysSection-module-scss-module__4pvHGa__carouselWrapper",
  "container": "CustomerSaysSection-module-scss-module__4pvHGa__container",
  "dots": "CustomerSaysSection-module-scss-module__4pvHGa__dots",
  "eyebrow": "CustomerSaysSection-module-scss-module__4pvHGa__eyebrow",
  "header": "CustomerSaysSection-module-scss-module__4pvHGa__header",
  "hpv2Blink": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2Blink",
  "hpv2DemoBounce": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2DemoBounce",
  "hpv2DemoFadeIn": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2DemoFadeIn",
  "hpv2DemoProgress": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2DemoProgress",
  "hpv2DemoScaleIn": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2DemoScaleIn",
  "hpv2DemoSlideIn": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2DemoSlideIn",
  "hpv2FadeLeft": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2FadeLeft",
  "hpv2FadeRight": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2FadeRight",
  "hpv2FadeUp": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2FadeUp",
  "hpv2FloatA": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2FloatA",
  "hpv2FloatB": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2FloatB",
  "hpv2HeroFadeIn": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2HeroFadeIn",
  "hpv2HeroFadeInOpacity": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2HeroFadeInOpacity",
  "hpv2HeroSlideIn": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2HeroSlideIn",
  "hpv2PriceShimmer": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2PriceShimmer",
  "hpv2PulseDot": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2PulseDot",
  "hpv2ScaleUp": "CustomerSaysSection-module-scss-module__4pvHGa__hpv2ScaleUp",
  "nextBtn": "CustomerSaysSection-module-scss-module__4pvHGa__nextBtn",
  "prevBtn": "CustomerSaysSection-module-scss-module__4pvHGa__prevBtn",
  "slide": "CustomerSaysSection-module-scss-module__4pvHGa__slide",
  "swiperTrack": "CustomerSaysSection-module-scss-module__4pvHGa__swiperTrack",
  "testimonialsSwiper": "CustomerSaysSection-module-scss-module__4pvHGa__testimonialsSwiper",
  "title": "CustomerSaysSection-module-scss-module__4pvHGa__title",
  "titleHighlight": "CustomerSaysSection-module-scss-module__4pvHGa__titleHighlight",
  "titleLine": "CustomerSaysSection-module-scss-module__4pvHGa__titleLine",
});
